<template>
  <div>
    <div class="grid-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>员工模块</el-breadcrumb-item>
        <el-breadcrumb-item>新增员工</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row :gutter="0" class="grid-content">
      <el-col :span="12">
         <div class="inputDiv">
          <div class="inputLeft">登陆账号：</div>
          <el-input v-model="user.username" style="width: unset;" placeholder="请输入登陆账号"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">员工姓名：</div>
          <el-input v-model="user.name" style="width: unset;" placeholder="请输入员工名称"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">员工电话：</span>
          <el-input
            v-model="user.tel"
            class="inputRight"
            maxlength="11"
            style="width: unset;"
            placeholder="请输入员工电话"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">登陆密码：</span>
          <el-input
            v-model="user.pass"
            class="inputRight"
            style="width: unset;"
            placeholder="请输入登陆密码"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">部门：</div>
          <!-- <el-date-picker
            v-model="user.deptName"
            type="date"
            style="width:200px"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"></el-date-picker> -->
            <el-select v-model="user.deptId" style="width:200px" placeholder="请选择员工部门">
            <el-option
              v-for="item in deptList"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">生日：</div>
          <el-date-picker
            v-model="user.birthday"
            type="date"
            style="width:200px"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"></el-date-picker>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">性别：</span>
          <el-select v-model="user.gender" style="width:200px" placeholder="请选择员工性别">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">地址：</div>
          <el-input v-model="address.province" class="inputdi" :disabled="true" placeholder="省"></el-input>
          <el-input v-model="address.city" class="inputdi" :disabled="true" placeholder="市"></el-input>
          <el-input v-model="address.county" class="inputdi" :disabled="true" placeholder="区"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">详细地址：</div>
          <el-input
            v-model="address.add"
            class="inputRight"
            type="textarea"
            :rows="2"
            style="width: unset;"
            placeholder="请输入详细地址"></el-input>
        </div>
        <div class="inputDiv">
          <el-button type="primary" class="widthButton" @click="add">确认</el-button>
          <el-button class="widthButton" @click="back">取消</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { userAdd } from "@/api/uesr";
import { deptSel } from "@/api/department";
export default {
  data() {
    return {
      address: {
        province: localStorage.getItem("province"),
        city: localStorage.getItem("city"),
        county: localStorage.getItem("county"),
        add: ""
      },
      user: {
        username:"",
        name: "",
        pass: "",
        tel: "",
        gender: "",
        deptId:"",
        birthday: ""
      },
      options: [
        {
          value: 1,
          label: "男"
        },
        {
          value: 2,
          label: "女"
        }
      ],
      deptList:[]
    };
  },
  mounted(){
    this.getDeptList()
  },
  methods: {
    add() {
      const params = {
        username: this.user.username,
        pass: this.user.pass,
        tel: this.user.tel,
        name: this.user.name,
        enterpriseId: localStorage.getItem("company_id"),
        enterpriseName:localStorage.getItem("company_name"),
        deptId:this.user.deptId,
        province: this.address.province,
        city: this.address.city,
        county: this.address.county,
        birthday: this.user.birthday,
        address: this.address.add,
        role: 3,
        salaryMode: 1,
        percentage: 0.0,
        gender: this.user.gender,
        baseSalary: 0,
        remark: localStorage.getItem("company_name"),
        states: 1
      };
      userAdd(params)
        .then(res => {
          if (res.count == 1) {
            this.$message({
              message: "创建成功",
              type: "success"
            });
            this.$router.go(-1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    back() {
      this.$router.go(-1);
    },
    getDeptList(){
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        states: 1,
        pageNum: 1,
        pageSize: 500
      };
      deptSel(params)
        .then(res => {
          this.deptList = [];
          res.gridData.forEach(element => {
            //element.state = getBatchStates(element.progress);
            const deptData = {
              value:element.id,
              label:element.name,
            }
            this.deptList.push(deptData);
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style>
</style>
